<template>
  <v-row class="pa-0 ma-0">
    <v-card tile>
      <v-toolbar flat height="60px" color="primary">
        <v-layout align-center>
          <v-btn v-if="close" fab x-small color="white" depressed @click="onClose()">
            <v-icon color="primary">close</v-icon>
          </v-btn>
          <v-toolbar-title class="white--text pl-2">{{ type == 'tos' ? '利用規約' : '個人情報保護方針'}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-layout>
      </v-toolbar>
      <v-divider></v-divider>
      <template v-if="type == 'tos'">
        <v-sheet class="overflow-y-auto pa-2" :style="contentsHeight">
          <v-card-text>
            このウェブサイト（以下「当サービス」といいます）は<a href='http://freewill.education' target='_blank'>（株）Freewill トータルエデュケーション</a>が運営しております。お客様が当サービスをご利用されるにあたっては、以下の利用規約をお読み頂き、同意される場合にのみご利用下さい。なお、本規約につきましては予告なく変更することがありますので、あらかじめ御了承下さい。
          </v-card-text>
          <v-card-text>
            第1条【サービス】<br>
            1．当サービスの利用に際してはウェブにアクセスする必要がありますが、利用者は自らの費用と責任に必要な機器・ソフトウェア・通信手段等を用意し適切に接続・操作することとします。<br>
            2．当サービスでは塾マネジメントに関するサービスの提供を行っておりますが、将来、様々なサービスを追加したり、または変更・削除することがあります<br>
            3．弊社は、当サービスが提供及び付随するサービスに対する保証行為を一切しておりません。また、弊社は、当サービスの提供するサービスの不確実性・サービス停止等に起因する利用者への損害について、一切責任を負わないものとします。詳細については、「免責事項について」をご覧下さい。
          </v-card-text>
          <v-card-text>
            第2条【個人情報の取り扱い】<br>
            当サービスの利用に際して利用者から取得した氏名、メールアドレス等の個人情報は、別途定める「Privacy Policy（個人情報保護方針）」に則り取り扱われます。
          </v-card-text>
          <v-card-text>
            第3条【著作権等知的財産権】<br>
            1. 当サービス内のプログラム、写真その他の知的財産権は弊社に帰属します。利用者は、当該情報を私用目的で利用される場合にかぎり使用できます。弊社に無断で、それを越えて、使用（複製、送信、譲渡、二次利用等を含む）することは禁じます。<br>
            2. 当サービス内の商標は、当該商標権を有する団体に帰属しますので、無断で使用することはできません。
          </v-card-text>
          <v-card-text>
            第4条【禁止事項】<br>
            1. 弊社は、利用者が以下の行為を行うことを禁じます。<br>
            （1） 弊社または第三者に損害を与える行為、または損害を与える恐れのある行為<br>
            （2） 弊社または第三者の財産、名誉、プライバシー等を侵害する行為、または侵害する恐れのある行為<br>
            （3） 公序良俗に反する行為、またはその恐れのある行為<br>
            （4） 他人のメールアドレスを登録するなど、虚偽の申告、届出を行う行為<br>
            （5） コンピュータウィルス等有害なプログラムを使用または提供する行為
            （6） 迷惑メールやメールマガジン等を一方的に送付する行為<br>
            （7） その他、法令に違反する行為、またはその恐れがある行為<br>
            （8） その他弊社が不適切と判断する行為
          </v-card-text>
          <v-card-text>
            2. 上記に違反した場合、弊社は利用者に対し損害賠償請求をすることができることに利用者は同意します。
          </v-card-text>
          <v-card-text>
            第5条【免責事項】<br>
            1. 弊社は、当サービスに掲載されている全ての情報を慎重に作成し、また管理しますが、その正確性および完全性などに関して、いかなる保証もするものではありません。<br>
            2. 弊社は、予告なしに、本サービスの運営を停止または中止し、また本サービスに掲載されている情報の全部または一部を変更する場合があります。<br>
            3. 利用者が当サービスを利用したこと、または何らかの原因によりこれをご利用できなかったことにより生じる一切の損害および第三者によるデータの書き込み、不正なアクセス、発言、メールの送信等に関して生じる一切の損害について、弊社は、何ら責任を負うものではありません。
          </v-card-text>
          <v-card-text>
            第6条【契約解除】<br>
            1. 弊社は、利用者が本規約に反する行為をした場合、即時にサービスを停止することができます。<br>
            2. 前項の事由が発生したとき、弊社は利用者に損害賠償をすることができます。
          </v-card-text>
          <v-card-text>
            第7条【損害賠償】<br>
            本規約に違反した場合、弊社に発生した損害を賠償していただきます。
          </v-card-text>
          <v-card-text>
            第8条【管轄裁判所】<br>
            万が一裁判所での争いとなったときは、東京地方裁判所を第一審の専属管轄裁判所とします。
          </v-card-text>
          <v-card-text>
            第9条【特例】<br>
            1. 本規約に基づき、特別の規定が別途定められている場合があります。<br>
            2. 弊社の各サービスの説明のページに当規約と相反する規定があった場合は、各サービスの説明ページに記載してある規定を適用します。
          </v-card-text>
          <v-card-text>
            （附則）<br>
            本規約は、2019年10月1日より施行致します。
          </v-card-text>
          <v-card-text>
            2019年10月1日制定
          </v-card-text>
        </v-sheet>
      </template>
      <template v-else>
        <v-sheet class="overflow-y-auto pa-2" :style="contentsHeight">
          <v-card-text>
            <a href='http://freewill.education' target='_blank'>（株）Freewill トータルエデュケーション</a>（以下，「当社」といいます。）は，本ウェブサイト上で提供するサービス（以下,「本サービス」といいます。）におけるプライバシー情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。
          </v-card-text>
          <v-card-text>
            第1条【プライバシー情報】<br>
            1．プライバシー情報のうち「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，連絡先その他の記述等により特定の個人を識別できる情報を指します。<br>
            2．プライバシー情報のうち「履歴情報および特性情報」とは，上記に定める「個人情報」以外のものをいい，ご利用いただいたサービスや，ご覧になったページや広告の履歴，ユーザーが検索された検索キーワード，ご利用日時，ご利用の方法，ご利用環境，年齢，ユーザーのIPアドレス，クッキー情報，位置情報，端末の個体識別情報などを指します。
          </v-card-text>
          <v-card-text>
            第2条【プライバシー情報の収集方法】<br>
            1. 当社は，ユーザーが利用登録をする際に氏名，生年月日，メールアドレス，などの個人情報をお尋ねすることがあります。<br>
            2. 当社は，ユーザーについて，利用したサービスやソフトウエア，閲覧したページや広告の履歴，検索した検索キーワード，利用日時，利用方法，利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態，利用に際しての各種設定情報なども含みます），IPアドレス，クッキー情報，位置情報，端末の個体識別情報などの履歴情報および特性情報を，ユーザーが当社のサービスを利用しまたはページを閲覧する際に収集します。
          </v-card-text>
          <v-card-text>
            第3条【個人情報を収集・利用する目的】<br>
            1. 当社が個人情報を収集・利用する目的は，以下のとおりです。<br>
            （1）ユーザーに自分の登録情報の閲覧や修正，利用状況の閲覧を行っていただくために，氏名，などの登録情報，利用されたサービスに関する情報を表示する目的<br>
            （2）ユーザーにお知らせや連絡をするためにメールアドレスを利用するする目的<br>
            （3）ユーザーの本人確認を行うために，氏名，生年月日，などの情報を表示する目的<br>
            （4）ユーザーが簡便にデータを入力できるようにするために，当社に登録されている情報を入力画面に表示させたり，ユーザーのご指示に基づいて他のサービスなど（提携先が提供するものも含みます）に転送したりする目的<br>
            （5）第三者に損害を発生させたりするなど，本サービスの利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの利用をお断りするために，利用態様，氏名など個人を特定するための情報を利用する目的<br>
            （6）ユーザーからのお問い合わせに対応するために，お問い合わせ内容や当社がユーザーに対してサービスを提供するにあたって必要となる情報や，ユーザーのサービス利用状況，連絡先情報などを利用する目的<br>
            （7）上記の利用目的に付随する目的
          </v-card-text>
          <v-card-text>
            第4条【個人情報の第三者提供】<br>
            1. 当社は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。<br>
            （1）法令に基づく場合<br>
            （2）人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき<br>
            （3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき<br>
            （4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより・当該事務の遂行に支障を及ぼすおそれがあるとき<br>
            （5）予め次の事項を告知あるいは公表をしている場合<br>
            ・利用目的に第三者への提供を含むこと<br>
            ・第三者に提供されるデータの項目<br>
            ・第三者への提供の手段または方法<br>
            ・本人の求めに応じて個人情報の第三者への提供を停止すること
          </v-card-text>
          <v-card-text>
            2. 前項の定めにかかわらず，次に掲げる場合は第三者には該当しないものとします。<br>
            （1）当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合<br>
            （2）合併その他の事由による事業の承継に伴って個人情報が提供される場合<br>
            （3）個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いているとき
          </v-card-text>
          <v-card-text>
            第5条【個人情報の開示】<br>
            1. 当社は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。なお，個人情報の開示に際しては，1件あたり 1,000円の手数料を申し受ける場合があります。<br>
            （1）本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合<br>
            （2）当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合<br>
            （3）その他法令に違反することとなる場合<br>
            2. 前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。
          </v-card-text>
          <v-card-text>
            第6条【個人情報の訂正および削除】<br>
            1. ユーザーは，当社の保有する自己の個人情報が誤った情報である場合には，当社が定める手続きにより，当社に対して個人情報の訂正または削除を請求することができます。<br>
            2. 当社は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正または削除を行い，これをユーザーに通知します。
          </v-card-text>
          <v-card-text>
            第7条【個人情報の利用停止等】<br>
            当社は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行い，その結果に基づき，個人情報の利用停止等を行い，その旨本人に通知します。ただし，個人情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じます。
          </v-card-text>
          <v-card-text>
            第8条【プライバシーポリシーの変更】<br>
            1. 本ポリシーの内容は，ユーザーに通知することなく，変更することができるものとします。<br>
            2. 当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。
          </v-card-text>
          <v-card-text>
            第9条【お問い合わせ窓口】<br>
            本ポリシーに関するお問い合わせは，以下にお願いいたします。<br>
            <br>
            住所：〒150-0022 東京都渋谷区恵比寿南2-24-9<br>
            電話：03-3760-0291（代表）<br>
            担当：柴山 健太郎<br>
            <br>
            以上
          </v-card-text>
          <v-card-text>
            （附則）<br>
            本ポリシーは、2019年10月1日より施行致します。
          </v-card-text>
          <v-card-text>
            2019年10月1日制定<br>
          </v-card-text>
        </v-sheet>
      </template>
    </v-card>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 1) + 'px;'
    }
  },
  data () {
    return {
    }
  },
  props: [ 'type', 'close' ],
  created () {
  },
  methods: {
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style scoped>
</style>
